import style from "@/styles/main.module.scss";

export function css(...classNames: any[]) {
    let classes = classNames
        .filter((name) => typeof name === "string")
        .join(" ")
        .split(" ")
        .filter((cls) => !!cls.trim());

    return classes
        .map((className) => {
            const classId = style[className];

            if (classId) {
                return `${className}-> ${classId}`;
            }

            return className;
        })
        .join(" ");
}
